


























import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({})
export default class DeliveryTab extends Vue {
  @Prop({required: true, default: 'group'}) private type!: string;
}
